import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { MEDIA } from '@/data/plotData';
import { useLanguage } from '@/context/LanguageContext';

const RENDERS = [
  { src: MEDIA.renderFront, en: 'Community front view with villas', ta: 'வில்லாக்களுடன் சமூக முன்பக்க காட்சி' },
  { src: MEDIA.renderOblique, en: 'Elevated layout with villa plots', ta: 'வில்லா பிளாட்டுகளின் உயர்நிலை காட்சி' },
];

export default function VillaRenderView({ area = 1195, plotId = 1, className = '' }) {
  const { lang } = useLanguage();
  const [idx, setIdx] = useState(0);

  const next = () => setIdx((i) => (i + 1) % RENDERS.length);
  const prev = () => setIdx((i) => (i - 1 + RENDERS.length) % RENDERS.length);

  return (
    <div className={`relative rounded-2xl overflow-hidden border border-[#E5DFD3] bg-[#F4F1EA] ${className}`}>
      {/* Image */}
      <div className="relative aspect-[16/10] overflow-hidden">
        <AnimatePresence mode="wait">
          <motion.img
            key={idx}
            src={RENDERS[idx].src}
            alt={RENDERS[idx][lang]}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4 }}
            className="w-full h-full object-cover"
          />
        </AnimatePresence>

        {/* Plot info overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        <div className="absolute bottom-3 left-3 right-3 flex items-end justify-between">
          <div>
            <span className="bg-[#D48C57] text-white text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider">
              Plot #{plotId}
            </span>
            <p className="text-white font-serif text-sm font-bold mt-1.5">
              {area.toLocaleString()} sq.ft
            </p>
          </div>
          {/* Navigation */}
          <div className="flex gap-1.5">
            <button onClick={prev} className="w-7 h-7 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center hover:bg-white/40 transition-colors">
              <ChevronLeft className="w-4 h-4 text-white" />
            </button>
            <button onClick={next} className="w-7 h-7 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center hover:bg-white/40 transition-colors">
              <ChevronRight className="w-4 h-4 text-white" />
            </button>
          </div>
        </div>
      </div>

      {/* Disclaimer */}
      <p className="text-[#5C6A61] text-[10px] px-3 py-2 italic leading-relaxed">
        {lang === 'en'
          ? 'For representational purposes only. Property has open plots, not built-up villas. Villa design will be as per your specification.'
          : 'மாதிரிக்காக மட்டுமே. இந்த தளத்தில் கட்டப்பட்ட வில்லாக்கள் இல்லை. வில்லா வடிவமைப்பு உங்கள் விருப்பத்திற்கு ஏற்ப அமைக்கப்படும்.'
        }
      </p>
    </div>
  );
}
